import { render, staticRenderFns } from "./rightPanel.vue?vue&type=template&id=bc1ab96e&scoped=true&"
import script from "./rightPanel.vue?vue&type=script&lang=js&"
export * from "./rightPanel.vue?vue&type=script&lang=js&"
import style0 from "./rightPanel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./rightPanel.vue?vue&type=style&index=1&id=bc1ab96e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1ab96e",
  null
  
)

export default component.exports